module.exports = __webpack_public_path__ + "media/37_Long.7803cfb5.mp3";